/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
import {
  Avatar,
  Typography,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Radio,
} from '@material-ui/core';
import Classnames from 'classnames';
const { selectProductEntities } = Slices.productSlice;
const { selectCountryValidations, getVariantConfig } = Slices.configSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { updateProductPayload } = Slices.tempCartSlice;
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import css from './index.module.scss';
import { useLocation } from '@reach/router';

// PRODUCT CONFIGURABLE GROUP COMPONENT DECLARATION
function ProductConfigurableGroup({
  variationPrice,
  productID,
  refReference,
  update,
  selectedSize,
  setOptMainId,
  title,
  isDesktop,
  uniqueName,
  variationId,
  variantImageBase,
}) {
  const intl = useIntl();
  const dispatch = useDispatch();
  const location = useLocation();
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const productsMap = useSelector(selectProductEntities);
  const tempItems = useSelector((state) => state.tempCart);
  const cartItems = useSelector((state) => state.cart);
  const variationConfig = useSelector(getVariantConfig);

  const locationSearch = new URLSearchParams(location.search);
  const isBundleItem = locationSearch.has('main_product') || false;
  const mainProductId = locationSearch.get('main_product');
  let stepId = parseInt(locationSearch.get('step'));

  const productCustomization = tempItems.data?.items?.find(
    (product) => product.id == (isBundleItem ? mainProductId : productID)
  );

  let currentVariation, currentProductVariation;
  let variation = variationConfig.filter((v) => title.includes(v[`key_${intl.locale}`]));
  if (variation?.length) variation = variation[0];

  let variationArray = [-1, -1, -1];

  if (!isBundleItem) {
    Object.values(productCustomization?.variants || {}).forEach((variant, index) => {
      variationArray[index] = variant;
    });

    currentProductVariation = productsMap[productID]?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });

    currentVariation = productsMap[productID]?.variants?.find(
      (variant) => variant.id == variationId
    );

    currentProductVariation = productsMap[productID]?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  } else {
    let stepInfo;
    if (
      productsMap[mainProductId]?.isBOGO ||
      productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
    ) {
      const paramsStepId = parseInt(locationSearch.get('step'));
      const optionId = parseInt(locationSearch.get('option'));

      let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
        let itemInfo;
        if (!item?.id) {
          itemInfo = productsMap[item];
        } else {
          itemInfo = item;
        }

        return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
      });

      if (!bgSteps?.id) {
        bgSteps = productsMap[bgSteps];
      }

      if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
        bgSteps = productsMap[bgSteps?.id];
      }

      stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
    } else {
      stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
    }

    const productInfo = stepInfo?.options?.find((option) => option?.id == productID);

    if (productCustomization?.bundle?.[stepId]?.[productID]?.variants) {
      Object.values(productCustomization?.bundle?.[stepId]?.[productID]?.variants).forEach(
        (variant, index) => {
          variationArray[index] = variant;
        }
      );
    } else {
      Object.values(productInfo?.variants || {}).forEach((variant, index) => {
        const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
        if (selectedOption) {
          variationArray[index] = selectedOption?.id;
        }
      });
    }

    currentVariation = productInfo?.variants?.find((variant) => variant.id == variationId);

    currentProductVariation = productInfo?.items?.find((item) => {
      let isVariantSame = true;
      variationArray.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  }

  // HANDLE RADIO
  const handleRadio = React.useCallback((value) => {
    let newProductCustomization = JSON.parse(JSON.stringify(productCustomization || {}));
    let variationArray = [-1, -1, -1];

    if (isBundleItem) {
      if (!newProductCustomization['bundle'][stepId]) {
        newProductCustomization['bundle'][stepId] = {};
      }
      if (!newProductCustomization['bundle'][stepId][productID]) {
        newProductCustomization['bundle'][stepId][productID] = {};
      }
      if (!newProductCustomization['bundle'][stepId][productID]['variants']) {
        newProductCustomization['bundle'][stepId][productID]['variants'] = {};
      }

      newProductCustomization['bundle'][stepId][productID]['variants'][variationId] = value;
      delete newProductCustomization['bundle'][stepId][productID]['items'];

      Object.values(newProductCustomization['bundle'][stepId][productID].variants).forEach(
        (variant, index) => {
          variationArray[index] = variant;
        }
      );
    } else {
      newProductCustomization['variants'][variationId] = value;
      delete newProductCustomization['items'];

      Object.values(newProductCustomization.variants).forEach((variant, index) => {
        variationArray[index] = variant;
      });
    }

    let currentProductVariation = getProductWithVariation(variationArray);
    if (currentProductVariation?.length) {
      currentProductVariation = currentProductVariation[0];
    } else {
      currentProductVariation = null;
    }

    if (!currentProductVariation?.steps?.[0]?.options) {
      currentProductVariation = productsMap[productID]?.items?.find(
        (item) => item?.id == currentProductVariation?.id
      );
    }

    let items = {};
    // eslint-disable-next-line no-unused-expressions
    currentProductVariation?.steps?.forEach((step) => {
      items[step.id] = {};
      // eslint-disable-next-line no-unused-expressions
      step?.options?.forEach((option) => {
        if (option?.subOptions) {
          const selectedSubOptions = option?.subOptions?.filter(
            (subOption) => subOption.selected == 1
          );
          if (selectedSubOptions?.length > 0) {
            items[step.id][option.id] = {
              qty: selectedSubOptions?.length,
            };
          }
        } else {
          if (option?.selected == 1) {
            items[step.id][option.id] = {
              qty: 1,
            };
          }
        }
      });
      if (!Object.keys(items[step.id]).length) delete items[step.id];
    });

    let finalItems = {};
    for (let [keys, vals] of Object.entries(items)) {
      if (vals) {
        finalItems[keys] = vals;
      }
    }

    if (isBundleItem) {
      if (Object.keys(finalItems)?.length)
        newProductCustomization['bundle'][stepId][productID]['items'] = finalItems;
    } else {
      if (Object.keys(finalItems)?.length) newProductCustomization['items'] = finalItems;
    }

    setTimeout(() => {
      dispatch(
        updateProductPayload({
          data: newProductCustomization,
        })
      );
    }, 0);
  });

  //! ONLY FOR HORIZONAL Price i.e., Size
  const checkProductPrice = (id, orientation) => {
    let product;
    if (isBundleItem) {
      if (productsMap[mainProductId]?.isBOGO) {
        const optionId = parseInt(locationSearch.get('option'));
        product = productsMap[mainProductId]?.items
          ?.find((item) => item?.id == optionId)
          ?.steps?.find((step) => step?.id == stepId)
          ?.options?.find((option) => option.id == productID);
      } else {
        product = productsMap[mainProductId]?.steps
          ?.find((step) => step?.id == stepId)
          ?.options?.find((option) => option.id == productID);
      }
    } else {
      product = productsMap[productID];
    }

    let productVariationsArray = [-1, -1, -1];

    Object.values(product?.variants || {}).forEach((variant, index) => {
      const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
      if (selectedOption) {
        productVariationsArray[index] = selectedOption?.id;
      }
    });

    productVariationsArray[0] = id;

    if (product?.items && product?.items.length) {
      const items = product?.items.filter((element) => {
        const newElement = element.id ? element.id : element;

        let isVariantSame = true;
        productVariationsArray.forEach((variant, index) => {
          if (productsMap[newElement]?.[`sel${index + 1}Value`] != variant) {
            isVariantSame = false;
          }
        });
        return isVariantSame;
      });

      let leastExpensiveItem =
        items?.length > 0
          ? items.reduce((prev, curr) => {
              return (prev?.price >= 0 ? prev?.price : prev?.specialPrice || prev?.currentPrice) <
                (curr?.price >= 0 ? curr?.price : curr?.specialPrice || curr?.currentPrice)
                ? prev
                : curr;
            })
          : 0;

      return decimalChecker(
        leastExpensiveItem?.price >= 0
          ? leastExpensiveItem?.price
          : leastExpensiveItem?.specialPrice || leastExpensiveItem?.originalPrice
      );
    }
  };

  const getProductWithVariation = (variations) => {
    let product;
    if (isBundleItem) {
      let stepInfo;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = stepId;
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
      }
      product = stepInfo?.options?.find((option) => option.id == productID);
    } else {
      product = productsMap[productID];
    }

    return product?.items?.filter((item) => {
      let isVariantSame = true;
      variations.forEach((variant, index) => {
        if (item[`sel${index + 1}Value`] != variant) {
          isVariantSame = false;
        }
      });
      return isVariantSame;
    });
  };

  // SCROLL ID OF SELECTED ITEM
  let scrollId = `${title.replace(/[\W_]/g, '').split(' ').join('')}-${variationId}`;
  // code to check if the select variation is available or not
  let productCustomizationPayload, productVariants;
  let productObj = productsMap[productID];
  if (isBundleItem) {
    let productInfo = Object.values(
      tempItems?.data?.items?.find((prod) => prod.id == mainProductId)?.['bundle'] || {}
    )?.find((prod) => Object.keys(prod[productObj?.id] || {}).length > 0);
    productVariants = productInfo?.[productObj?.id]?.variants;

    productCustomizationPayload =
      tempItems?.data?.items?.find((prod) => prod?.id == mainProductId)?.['bundle']?.[stepId]?.[
        productObj?.id
      ] ||
      tempItems?.customize?.items?.find((prod) => prod?.id == mainProductId)?.['bundle']?.[
        stepId
      ]?.[productObj?.id];
  } else {
    let isProductInCart =
      cartItems.data.items.filter((product) => product?.id == productObj?.id)?.length > 0;
    if (isProductInCart) {
      productVariants = tempItems.data.items.find((product) => product?.id == productObj?.id)
        ?.variants;
    }

    productCustomizationPayload =
      tempItems?.data?.items?.find((prod) => prod.id == productObj.id) ||
      tempItems?.customize?.items?.find((prod) => prod.id == productObj.id);
  }

  let selectedVariants = [];
  if (productCustomizationPayload || productVariants) {
    selectedVariants = Object.values(
      productVariants || productCustomizationPayload?.variants || {}
    );
  } else {
    let product;
    if (isBundleItem) {
      let stepInfo;
      if (
        productsMap[mainProductId]?.isBOGO ||
        productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
      ) {
        const paramsStepId = stepId;
        const optionId = parseInt(locationSearch.get('option'));

        let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
          let itemInfo;
          if (!item?.id) {
            itemInfo = productsMap[item];
          } else {
            itemInfo = item;
          }

          return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
        });

        if (!bgSteps?.id) {
          bgSteps = productsMap[bgSteps];
        }

        if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
          bgSteps = productsMap[bgSteps?.id];
        }

        stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
      } else {
        stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
      }
      product = stepInfo?.options?.find((option) => option.id == productID);
    } else {
      product = productsMap[productID];
    }

    const defaultVariationArray = new Array(3).fill(-1);
    for (let variation of product?.variants || []) {
      const selectedOption = variation?.options?.find((option) => option?.isSelected == 1)?.id;
      defaultVariationArray[variation?.selIndex - 1] = selectedOption;
    }
    selectedVariants = defaultVariationArray;
  }

  for (let i = 0; i < 3; i++) {
    if (!selectedVariants[i]) selectedVariants[i] = -1;
  }

  // RETURN METHOD
  if (variation?.orientation == 'horizontal') {
    return (
      <div className={css.root} id={scrollId} ref={refReference}>
        <Typography
          variant="h2"
          className={Classnames(css.listTitle, {
            [css.currentActiveLink]:
              isDesktop && uniqueName === localStorage.getItem('activeIndex'),
            [css.styleDesktop]: isDesktop,
          })}
        >
          {title}
        </Typography>
        <List
          disablePadding
          className={Classnames(css.listContainer, css.horizontalTab)}
          id={`${scrollId}`}
        >
          {/* PRODUCT VARIANTS RENDERING */}
          {currentVariation?.options.map((condiment, idx) => {
            const optionVariation = variation?.variations?.find(
              (v) =>
                v[`key_${intl.locale}`]?.toLowerCase() == condiment?.title.toLowerCase() ||
                v[`alternate_key_${intl.locale}`]
                  ?.toLowerCase()
                  ?.includes(condiment?.title?.toLowerCase() || condiment?.title)
            );

            let currentStepId = productsMap[mainProductId]?.isBOGO
              ? locationSearch.get('step')
              : stepId;

            const isChecked = isBundleItem
              ? Object.values(
                  productCustomization?.['bundle']?.[currentStepId]?.[productID]?.['variants'] || {}
                ).includes(condiment?.id)
              : condiment?.id == productCustomization?.variants?.[variationId];

            const key = `ConfigGroup-${condiment.title}-${condiment.id}`;
            const price = checkProductPrice(condiment.id, variation?.orientation) || '';
            const img = optionVariation
              ? variantImageBase + optionVariation?.image
              : condiment?.assets[0]?.src;

            let currentVariationObj = [...selectedVariants];
            currentVariationObj[0] = condiment?.id;

            if (!isBundleItem) {
              currentProductVariation = Object.values(productObj?.items || [])?.find((item) => {
                let currentProductItem = productsMap?.[item?.id || item] || item;

                let isVariantSame = true;
                currentVariationObj.forEach((variant, index) => {
                  if (variant > -1 && currentProductItem?.[`sel${index + 1}Value`] != variant) {
                    isVariantSame = false;
                  }
                });

                return isVariantSame;
              });
            } else {
              let stepInfo;
              if (
                productsMap[mainProductId]?.isBOGO ||
                productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
              ) {
                const paramsStepId = parseInt(locationSearch.get('step'));
                const optionId = parseInt(locationSearch.get('option'));

                let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
                  let itemInfo;
                  if (!item?.id) {
                    itemInfo = productsMap[item];
                  } else {
                    itemInfo = item;
                  }
                  return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
                });
                if (!bgSteps?.id) {
                  bgSteps = productsMap[bgSteps];
                }

                if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
                  bgSteps = productsMap[bgSteps?.id];
                }

                stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
              } else {
                stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
              }

              const productInfo = stepInfo?.options?.find(
                (option) => option?.id == productObj?.id || option?.id == productID
              );

              if ((productInfo?.items?.length || 0) < 2 || productInfo?.typeId == 'simple') {
                currentProductVariation = productInfo?.items?.[0] || productInfo;
              } else {
                currentProductVariation = Object.values(productInfo?.items || [])?.find((item) => {
                  let isVariantSame = true;
                  currentVariationObj.forEach((variant, index) => {
                    let productItem = productsMap?.[item?.id || item] || item;
                    if (productItem?.[`sel${index + 1}Value`] != variant) {
                      isVariantSame = false;
                    }
                  });
                  return isVariantSame;
                });
              }
            }

            if (!currentProductVariation?.id)
              currentProductVariation = productsMap[currentProductVariation];

            return (
              <ListItem
                button={true}
                key={key}
                component="button"
                disabled={!currentProductVariation}
                htmlFor={key}
                onClick={(event, value) => handleRadio(condiment.id)}
                className={Classnames(css.listItem, css.horizontalItem)}
              >
                <Avatar
                  variant="square"
                  alt={condiment.title}
                  src={`${img}`}
                  className={css.image}
                />
                <ListItemText
                  primary={`${optionVariation?.[`key_${intl.locale}`] || condiment.title}`}
                  className={css.title}
                />
                <ListItemText
                  primary={`(${
                    optionVariation?.[`subtitle_${intl.locale}`] ||
                    optionVariation?.[`subtitle_en`] ||
                    ''
                  })`}
                  className={css.subtitle}
                />
                {!currentProductVariation ? (
                  <ListItemText
                    primary={<FormattedMessage id="not_available" defaultMessage="Not Available" />}
                    className={css.notAvailable}
                  />
                ) : price > 0 ? (
                  <ListItemText
                    primary={`${price || 0} ${countryValidations?.currency}`}
                    className={css.subtitle2}
                  />
                ) : (
                  ''
                )}
                <ListItemSecondaryAction className={css.radio}>
                  <Radio
                    edge="end"
                    id={key}
                    color="primary"
                    disabled={!currentProductVariation}
                    checked={isChecked}
                  />
                </ListItemSecondaryAction>
              </ListItem>
            );
          })}
        </List>
      </div>
    );
  }

  let defaultVariationArray = [-1, -1, -1];

  let stepInfo;
  if (
    productsMap[mainProductId]?.isBOGO ||
    productsMap[mainProductId]?.bundleTypeId == 'bundle_group'
  ) {
    const paramsStepId = parseInt(locationSearch.get('step'));
    const optionId = parseInt(locationSearch.get('option'));

    let bgSteps = productsMap[mainProductId]?.items?.find((item) => {
      let itemInfo;
      if (!item?.id) {
        itemInfo = productsMap[item];
      } else {
        itemInfo = item;
      }

      return itemInfo?.id == optionId || itemInfo?.sel1Value == optionId;
    });

    if (!bgSteps?.id) {
      bgSteps = productsMap[bgSteps];
    }

    if (!Array.isArray(bgSteps?.steps) || !bgSteps?.steps?.length) {
      bgSteps = productsMap[bgSteps?.id];
    }

    stepInfo = bgSteps?.steps?.find((step) => step?.id == paramsStepId);
  } else {
    stepInfo = productsMap[mainProductId]?.steps?.find((step) => step?.id == stepId);
  }

  const productInfo = stepInfo?.options?.find((option) => option?.id == productID);

  Object.values(
    (isBundleItem ? productInfo?.variants : productsMap[productID]?.variants) || {}
  ).forEach((variant, index) => {
    const selectedOption = variant?.options?.find((option) => option?.isSelected == 1);
    if (selectedOption) {
      defaultVariationArray[index] = selectedOption?.id;
    }
  });

  return (
    <div className={css.root} ref={refReference}>
      <Typography
        variant="h2"
        className={Classnames(css.listTitle, {
          [css.currentActiveLink]: isDesktop && uniqueName === localStorage.getItem('activeIndex'),
          [css.styleDesktop]: isDesktop,
        })}
      >
        {title}
      </Typography>
      <List disablePadding className={css.listContainer} id={`${scrollId}`}>
        {/* PRODUCT VARIANTS RENDERING */}
        {currentVariation?.options?.map((condiment) => {
          const isChecked = isBundleItem
            ? Object.values(
                productCustomization?.['bundle']?.[stepId]?.[productID]?.['variants'] || {}
              )?.includes(condiment?.id)
            : condiment?.id == productCustomization?.variants?.[variationId];
          const key = `ConfigGroup-${condiment.title}-${condiment?.id}`;

          const configOption = currentVariation?.options?.filter(
            (config) => config?.id == condiment?.id
          );

          const img =
            configOption?.length > 0
              ? configOption[0]?.assets[0]?.src
              : currentVariation?.assets[0]?.src;

          let newVariationArray = JSON.parse(JSON.stringify(variationArray));
          newVariationArray[currentVariation.selIndex - 1] = condiment.id;
          let newVariationObject = getProductWithVariation(newVariationArray);
          if (newVariationObject?.length) {
            newVariationObject = newVariationObject[0];
          } else {
            newVariationObject = null;
          }

          defaultVariationArray[0] = newVariationArray[0];
          let defaultProductVariation = getProductWithVariation(defaultVariationArray);
          if (defaultProductVariation?.length) {
            defaultProductVariation = defaultProductVariation[0];
          } else {
            defaultProductVariation = null;
          }

          const priceDifference =
            (newVariationObject?.price >= 0
              ? newVariationObject?.price
              : newVariationObject?.specialPrice || newVariationObject?.originalPrice) -
            (defaultProductVariation?.price >= 0
              ? defaultProductVariation?.price
              : defaultProductVariation?.specialPrice || defaultProductVariation?.originalPrice);

          return (
            <ListItem
              disabled={!newVariationObject}
              button
              key={key}
              component="label"
              htmlFor={key}
              className={Classnames(css.listItem, isChecked ? css.activeClass : '')}
            >
              <Avatar variant="square" alt={condiment.title} src={img} className={css.image} />
              <div className={Classnames(css.titleContainer, css.marginStart)}>
                <ListItemText primary={condiment.title} className={css.title} />
                {!newVariationObject && (
                  <span className={css.notAvailable}>
                    <FormattedMessage id="not_available" defaultMessage="Not Available" />
                  </span>
                )}
                {!!priceDifference && (
                  <span className={css.priceSpan}>
                    <span className={`${priceDifference < 0 ? css.redText : css.greenText}`}>
                      {priceDifference > 0 ? '+' : '-'}
                    </span>
                    <span>{`${decimalChecker(Math.abs(priceDifference))} ${
                      countryValidations?.currency
                    }`}</span>
                  </span>
                )}
              </div>
              {condiment?.isSelected === 1 && (
                <div className={css.defaultSpan}>
                  <FormattedMessage id={'default'} defaultMessage={'DEFAULT'} />
                </div>
              )}
              <ListItemSecondaryAction className={css.radio}>
                <Radio
                  edge="end"
                  id={key}
                  color="primary"
                  disabled={!newVariationObject}
                  onChange={(event, value) => handleRadio(condiment.id)}
                  checked={isChecked}
                />
              </ListItemSecondaryAction>
            </ListItem>
          );
        })}
      </List>
    </div>
  );
}

export default ProductConfigurableGroup;
